module.exports = __webpack_public_path__ + "img/banner.61fd1271.png";